import { render, staticRenderFns } from "./tpl-6.vue?vue&type=template&id=d8bc6ac4&scoped=true&"
import script from "./tpl-6.vue?vue&type=script&lang=js&"
export * from "./tpl-6.vue?vue&type=script&lang=js&"
import style0 from "./tpl-6.vue?vue&type=style&index=0&id=d8bc6ac4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bc6ac4",
  null
  
)

export default component.exports